import actions from '@/vuex/modules/admin/request/mapReport/actions'
import getters from '@/vuex/modules/admin/request/mapReport/getters'
import mutations from '@/vuex/modules/admin/request/mapReport/mutations'
import { MapReportStatuses } from '@/models/MapReport'

const state = {
  keyword: '',
  advertiserId: 0,
  pageNo: 1,
  status: MapReportStatuses.Waiting,
  isAutoGenerated: null,
  mapReport: {},
}

const mapReport = {
  state,
  namespaced: true,
  getters,
  actions,
  mutations,
}

export default mapReport
